import { Box, Typography, Alert } from "@mui/material";

interface RealmErrorProps {
  hostname: string;
  error: string;
}

export function RealmError({ hostname, error }: RealmErrorProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 3,
      }}
    >
      <Alert severity="error" sx={{ maxWidth: 500 }}>
        <Typography variant="h6" gutterBottom>
          Unknown Domain
        </Typography>
        <Typography>
          The domain <strong>{hostname}</strong> is not configured for any
          realm. Please check the URL and try again.
        </Typography>
        {error && (
          <Typography variant="body2" sx={{ mt: 1, opacity: 0.7 }}>
            {error}
          </Typography>
        )}
      </Alert>
    </Box>
  );
}
